export const truncateString = (val, maxLength) =>
  val?.length > maxLength ? val.substr(0, maxLength - 2) + ".." : val;
